import {$getRoot, createEditor, EditorState} from "lexical";
import {ListNode, ListItemNode} from "@lexical/list";
import {LinkNode} from "@lexical/link";
import {HeadingNode, QuoteNode} from "@lexical/rich-text";
import {ImageNode} from "@common/components/forms/rich-text-form-field/nodes/image-node";
import {LoadingImageNode} from "@common/components/forms/rich-text-form-field/nodes/loading-image-node";
import {DashListNode} from "@common/components/forms/rich-text-form-field/nodes/dash-list-node";

export const normalizeRichTextPlainText = (text: string): string => {
    return text
        .replace(/\n+/g, "\n")
        .trim()
};

export const countRichTextLengthFromPlainText = (text: string): number => {
    if (!text) return 0;
    return normalizeRichTextPlainText(text).length;
};

export const getTextLengthFromEditorState = (editorState: EditorState): number => {
    let length = 0;

    editorState.read(() => {
        const text = $getRoot().getTextContent();
        length = countRichTextLengthFromPlainText(text);
    });

    return length;
};

export const getTextLengthFromJson = (json: string | null | undefined): number => {
    if (!json) return 0;

    try {
        const editor = createEditor({
            nodes: [
                ImageNode,
                LoadingImageNode,
                LinkNode,
                ListNode,
                ListItemNode,
                HeadingNode,
                QuoteNode,
                DashListNode,
            ],
        });

        const editorState = editor.parseEditorState(json);

        let length = 0;

        editorState.read(() => {
            const text = $getRoot().getTextContent();
            length = text.replace(/\n+/g, "\n").trim().length;
        });

        return length;
    } catch (e) {
        console.warn("⚠️ Failed to parse editor JSON:", e);
        return 0;
    }
};
